import type React from "react";
import {
  createContext,
  type Dispatch,
  type SetStateAction,
  useState,
} from "react";
import type { ContentPage } from "../interfaces/ContentPage";

// Context typing
interface ContentPagesContext {
  contentPages: ContentPage[];
  setContentPages: Dispatch<SetStateAction<ContentPage[]>>;
}

// Initial State
const initialState: ContentPage[] = [];

// Context init
const contentPagesStore = createContext<ContentPagesContext>({
  contentPages: initialState,
  setContentPages: () => null,
});

// Provider init
const { Provider } = contentPagesStore;

// Final setup
const ContentPagesProvider = ({ children }: { children: React.ReactNode }) => {
  const [contentPages, setContentPages] = useState(initialState);
  return (
    <Provider value={{ contentPages, setContentPages }}>{children}</Provider>
  );
};

export { ContentPagesProvider, contentPagesStore };
